import React from "react"
import { StaticQuery, graphql } from "gatsby"

const LocationsQuery = ({ 
  render: Render,
}) => (
  <StaticQuery
    query={graphql`
      query {
        allContentfulLocation {
          edges {
            node {
              id
              title
              neighborhood
              isActive
              slug
              calendlyId
              thumbnailImage {
                resize(width: 1000) {
                  src
                }
              }
              address {
                addressLine1
                city
                state
                zipCode
              }
              membershipOptions {
                id
              }
              phoneNumber
              email
              locationPDF {
                file {
                  url
                }
              }
            }
          }
        }
      }
    `}
    render={data => {
      const locations = data.allContentfulLocation.edges.map(({ node }) => node) || []
      
      const locationsByState = {}

      locations.forEach(location => {
        if (!location.address) return
        const { state } = location.address

        if (location.isActive) {
          locationsByState[state] = locationsByState[state] || { active: [], comingSoon: [] }
          locationsByState[state].active.push(location)
        }
      })

      return <Render 
        data={{ locations, locationsByState }} 
      />
    }}
  />
)

export default LocationsQuery
